import { createI18n } from 'vue-i18n';
import common from '@/locales/common.json';

export const i18n = createI18n({
	legacy: false,
	locale: 'en',
	fallbackLocale: 'en',
	messages: {}
});

const loadLocalizationFile = async (language: string, url: string) => {
	try {
		const base =
			import.meta.env.MODE !== 'development'
				? 'https://static-loyalty-system-r2.bgaming-network.com/master-v2'
				: url;

		// const response = await fetch(`${url}/l10n/${language}/common.json`);
		const response = await fetch(`${base}/l10n/${language}/common.json`);
		return await response.json();
	} catch (error) {
		return common;
	}
};

export const switchLanguage = async (locale: string, url: string) => {
	const messages = await loadLocalizationFile(locale, url);
	i18n.global.setLocaleMessage(locale, messages);
	// @ts-ignore
	i18n.global.locale.value = locale;
};
